import { createContext, useContext } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const EditorContext = /*#__PURE__*/createContext(null);
export function useEditorContext() {
  return useContext(EditorContext);
}
export function EditorProvider({
  children,
  editorControl,
  editorComponents
}) {
  const value = {
    editorControl,
    editorComponents
  };
  return _jsx(EditorContext.Provider, {
    value: value,
    children: children
  });
}